import { format, getHours, getMinutes, setHours, setMinutes } from 'date-fns'
import * as React from 'react'
import DayPicker from 'react-day-picker'
import { MoonLoader } from 'react-spinners'
import { IProviderProductObject } from '../../types/index'
import ButtonFilled from '../ui/ButtonFilledOrange'
import Modal from '../ui/Modal'
import UIMessages from 'src/utils/ui-messages'
import TimeSelector from '../ui/TimeSelector'

interface IProviderProductDeactivateModalProps {
  product: IProviderProductObject
  onCancelClick: () => void
  onDeactivateClick: (productId: string, deactivationDate: Date) => Promise<any>
}

interface IProviderProductDeactivateModalState {
  deactivationDate: Date
  updating: boolean
  error: string
}

class ProviderProductDeactivateModal extends React.Component<
  IProviderProductDeactivateModalProps,
  IProviderProductDeactivateModalState
> {
  constructor(props: IProviderProductDeactivateModalProps) {
    super(props)
    this.state = {
      deactivationDate: props.product && props.product.deactivationDate ? props.product.deactivationDate : new Date(),
      updating: false,
      error: ''
    }
  }

  public render() {
    const { deactivationDate, updating } = this.state
    const { product, onCancelClick } = this.props

    const containerStyle = {
      width: 550,
      height: 360
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>Deactivate Product</span>
            <div className='mt1 border-top pt2'>
              <div className='font-grey3 h5'>Do you want to deactivate this product?</div>
              <li className='h5 font-grey3 mx-auto mt1 bold'>
                {UIMessages.product.productName}: {product && product.name}
              </li>
              <li className='h5 font-grey3 mx-auto mt1 bold'>
                {UIMessages.product.productDescription}: {product && product.description}
              </li>
              <li className='h5 font-grey3 mx-auto mt1 bold'>
                {UIMessages.product.serviceLevel}:{' '}
                {product && product.providerServiceLevel && product.providerServiceLevel.name}
              </li>
            </div>
            <div className='flex items-center justify-end mt3'>
              <button type='button' onClick={onCancelClick} className='CancelButton custom-btn mbsc-clear-btn'>
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={this.onDeactivateClick}
                className={'SubmitButton custom-btn mbsc-red-btn ml1'}
              >
                Deactivate
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private onDeactivateClick = () => {
    if (this.props.product && this.props.product.id) {
      this.props.onDeactivateClick(this.props.product.id, this.state.deactivationDate)
    }
  }
}

export default ProviderProductDeactivateModal



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductDeactivateModal.tsx